import { render, staticRenderFns } from "./GoodsAttributeList.vue?vue&type=template&id=8f63fc86&scoped=true&"
import script from "./GoodsAttributeList.vue?vue&type=script&lang=js&"
export * from "./GoodsAttributeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f63fc86",
  null
  
)

export default component.exports